import Vue from "vue";
import Router from "vue-router";
import routes from "./router";

const originalPush: any = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// 初始化下拉列表
const initDetailList = () => {
  window.App.$store.dispatch("discover/getFeaturelist");
  // debugger;
};

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.publicPath,
  routes,
});

router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});

router.beforeEach(async (to, from, next) => {
  /* 路由发生变化修改页面title */
  // if (to.meta.title) {
  //     document.title = to.meta.title;
  // }
  next();
  /* must call `next` */
});

export default router;
